import React, {useState, useEffect} from "react";
import {Box, Alert, AlertTitle, Collapse, IconButton, Typography} from "@mui/material";
import {WifiOff as OfflineIcon, Wifi as OnlineIcon, Close as CloseIcon} from "@mui/icons-material";
import {isOnline, addConnectivityListeners, removeConnectivityListeners} from "../utils/pwaUtils";

const OfflineIndicator = () => {
  const [isOffline, setIsOffline] = useState(!isOnline());
  const [showAlert, setShowAlert] = useState(!isOnline());

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setShowAlert(false);
    };

    const handleOffline = () => {
      setIsOffline(true);
      setShowAlert(true);
    };

    addConnectivityListeners(handleOnline, handleOffline);

    return () => {
      removeConnectivityListeners(handleOnline, handleOffline);
    };
  }, []);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  if (!isOffline) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 1
      }}
    >
      <Collapse in={showAlert}>
        <Alert
          severity="warning"
          icon={<OfflineIcon />}
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={handleCloseAlert}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            borderRadius: 1,
            boxShadow: 2
          }}
        >
          <AlertTitle>You&apos;re offline</AlertTitle>
          <Typography variant="body2">
            Some features may not be available. Your data will sync when you&apos;re back online.
          </Typography>
        </Alert>
      </Collapse>
    </Box>
  );
};

export default OfflineIndicator;
